function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.975772,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.9412 12.4874V1.69945C17.5578 0.566484 14.1727 0 10.7859 0C7.39909 0 3.80379 0.566484 0 1.69945V12.4874C0 17.5016 2.7452 19.7566 7.17903 22.1938L10.4706 24L13.7622 22.1938C18.196 19.7566 20.9412 17.5016 20.9412 12.4874ZM10.4729 14.523L15.4219 11.5212L10.4729 3.08504L5.5206 11.5212L10.4729 14.523ZM5.5206 12.4852L10.4729 15.487L15.4252 12.4852L10.4729 19.6468L5.5206 12.4852Z",
  fill: "white"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5847 17.9269L22.8945 11.2366L29.5847 4.54636L29.5847 8.93036H32.4743V13.3144H29.5847L29.5847 17.9269Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/invoice.ec4f1efc.svg";
export { SvgComponent as ReactComponent };